const findChildren = (node, predicate) => {
  const nodesWithPos = [];
  node.descendants((child, pos) => {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos
      });
    }
  });
  return nodesWithPos;
};
export {
  findChildren
};
//# sourceMappingURL=find-children.js.map
